export default "__VITE_ASSET__qFxrDk1$__";